//@ts-nocheck
import React, {
  forwardRef,
  HTMLAttributes,
  ReactNode,
  useEffect,
  useRef,
  useState
} from 'react';
import { useModal, usePreventScroll } from '@react-aria/overlays';
import { mergeProps, useViewportSize } from '@react-aria/utils';
import cn from 'classnames';

interface TrayWrapperProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  isOpen?: boolean;
  onClose?: () => void;
  isFixedHeight?: boolean;
  isNonModal?: boolean;
  overlayProps: HTMLAttributes<HTMLElement>;
  label?: string;
  isSearchable?: boolean;
  trayContainerClassName?: string;
  trayChildrenWrapperClassName?: string;
}

export const TrayWrapper = forwardRef(function (
  props: TrayWrapperProps,
  ref: any
) {
  const {
    children,
    isOpen,
    isFixedHeight,
    isNonModal,
    overlayProps,
    label,
    isSearchable = true,
    trayContainerClassName,
    trayChildrenWrapperClassName,
    ...otherProps
  } = props;
  usePreventScroll();
  const { modalProps } = useModal({
    isDisabled: isNonModal
  });

  const viewport = useViewportSize();
  const [height, setHeight] = useState(viewport.height);
  const timeoutRef = useRef<any>();

  useEffect(() => {
    clearTimeout(timeoutRef.current);

    if (viewport.height < height && viewport.height < window.innerHeight) {
      timeoutRef.current = setTimeout(() => {
        setHeight(viewport.height);
      }, 500);
    } else {
      setHeight(viewport.height);
    }
  }, [height, viewport.height]);

  const domProps = mergeProps(otherProps, overlayProps);

  return (
    <div
      style={{ height: height }}
      className={cn(
        'fixed bottom-0 flex flex-col-reverse right-0 left-0 top-0 bg-blue-gray-600 bg-opacity-80 z-l10 w-full',
        trayContainerClassName
      )}
    >
      {/* @ts-ignore */}   
      <div
        {...domProps }
        {...modalProps}
        ref={ref}
        data-testid="tray"
        className={cn(
          'bottom-sheet-animation bg-base-white relative w-full flex flex-col rounded-t-16px',
          isSearchable ? 'relative top-64px h-full' : 'h-unset',
          trayChildrenWrapperClassName
        )}
      >
        {children}
      </div>
    </div>
  );
});
